(function () {
  'use strict';
  function removalUpdates(cart, key) {
    const parent = cart.items.find(item => item.key === key);
    if (!parent) return null;
    if (parent.parent_relationship?.parent_key || parent.properties?._gpo_parent_product_group || parent.instructions?.can_remove === false) throw new Error('Remove this option with its main piece.');
    const keys = new Set([key]);
    const groups = new Set();
    let changed = true;
    while (changed) {
      changed = false;
      cart.items.filter(item => keys.has(item.key)).forEach(item => {
        if (item.properties?._gpo_product_group) groups.add(item.properties._gpo_product_group);
      });
      cart.items.forEach(item => {
        if (!keys.has(item.key) && (keys.has(item.parent_relationship?.parent_key) || groups.has(item.properties?._gpo_parent_product_group))) {
          keys.add(item.key);
          changed = true;
        }
      });
    }
    return Object.fromEntries([...keys].map(itemKey => [itemKey, 0]));
  }
  if (typeof module === 'object' && module.exports) { module.exports = {removalUpdates}; return; }
  if (window.DSCartDrawer) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const triggers = 'a.bag-link, a.js-header-cart, a.header-cart__link, [data-ds-open-cart]';
  let dialog, content, opener, request = 0, removing = false;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = (value, currency) => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:currency || 'USD'}).format(Number(value || 0) / 100);
  function localUrl(value, fallback) {
    try { const url = new URL(value, location.origin); return url.origin === location.origin ? url.pathname + url.search : fallback; } catch { return fallback; }
  }
  function imageUrl(value) {
    try { const url = new URL(value, location.origin); return url.protocol === 'https:' ? url.href : ''; } catch { return ''; }
  }
  function close() { if (dialog?.open) dialog.close(); }
  function setup() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.id = 'ds-cart-drawer';
    dialog.setAttribute('aria-labelledby', 'ds-cart-title');
    dialog.innerHTML = '<header class="ds-bag-heading"><div><p>DIAMOND STUDIO</p><h2 id="ds-cart-title">Your shopping bag</h2></div><button type="button" data-ds-bag-close aria-label="Close shopping bag">×</button></header><div class="ds-bag-content"></div>';
    document.body.appendChild(dialog);
    content = dialog.querySelector('.ds-bag-content');
    dialog.addEventListener('close', () => {
      document.documentElement.classList.remove('ds-bag-open');
      document.querySelectorAll(triggers).forEach(node => node.setAttribute('aria-expanded', 'false'));
      if (opener?.isConnected) opener.focus({preventScroll:true});
    });
    dialog.addEventListener('click', event => {
      if (event.target.closest('[data-ds-bag-close]')) close();
      if (event.target.closest('[data-ds-bag-retry]')) refresh();
      const remove = event.target.closest('[data-ds-bag-remove]');
      if (remove) { event.preventDefault(); removeItem(remove); }
      if (event.target === dialog) {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      }
    });
  }
  async function cartRequest(path, init = {}) {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(root() + path, {...init, credentials:'same-origin', cache:'no-store', signal:controller.signal, headers:{Accept:'application/json', ...(init.headers || {})}});
      if (!response.ok) throw new Error('Your bag could not be updated. Please try again.');
      const cart = await response.json();
      if (!Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) throw new Error('Your bag could not be updated. Please try again.');
      return cart;
    } finally { clearTimeout(timer); }
  }
  async function removeItem(button) {
    if (removing) return;
    removing = true;
    ++request;
    const key = button.dataset.dsBagRemove;
    content.setAttribute('aria-busy', 'true');
    content.querySelectorAll('button').forEach(control => { control.disabled = true; });
    button.textContent = 'Removing…';
    let message = '';
    try {
      const cart = await cartRequest('cart.js');
      const updates = removalUpdates(cart, key);
      if (updates) {
        await cartRequest('cart/update.js', {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({updates})});
        message = 'Item removed from your bag.';
      } else {
        message = 'Your bag changed. Review the refreshed items before removing a piece.';
      }
    } catch {
      message = 'We couldn’t confirm the removal. Check your refreshed bag before trying again.';
    } finally {
      removing = false;
      await refresh();
      const status = document.createElement('p');
      status.className = 'ds-bag-removal-status';
      status.setAttribute('role', 'status');
      status.textContent = message;
      content.prepend(status);
      if (dialog.open) dialog.querySelector('[data-ds-bag-close]').focus({preventScroll:true});
    }
  }
  function syncCount(cart) {
    document.querySelectorAll('[data-cart-count], .ds-header-cart-count').forEach(node => { node.textContent = String(cart.item_count); node.hidden = !cart.item_count; });
    document.querySelectorAll('a.bag-link').forEach(link => {
      let badge = link.querySelector('.ds-header-cart-count');
      if (!badge && cart.item_count) { badge = document.createElement('span'); badge.className = 'ds-header-cart-count'; link.appendChild(badge); }
      if (badge) { badge.textContent = String(cart.item_count); badge.hidden = !cart.item_count; }
    });
  }
  function render(cart) {
    syncCount(cart);
    if (!cart.items.length) {
      content.innerHTML = '<div class="ds-bag-empty"><h3>A little room for something extraordinary.</h3><p>Your shopping bag is empty.</p><button type="button" class="ds-bag-button" data-ds-bag-close>Continue shopping</button></div>';
      return;
    }
    const rows = cart.items.map((item, index) => {
      const options = (item.options_with_values || []).filter(option => option.value !== 'Default Title').map(option => '<p>' + escape(option.name) + ': ' + escape(option.value) + '</p>').join('');
      const properties = Object.entries(item.properties || {}).filter(([key, value]) => key[0] !== '_' && value !== '' && value != null).map(([key, value]) => '<p>' + escape(key === 'image-swatches-1' ? 'Gold Color' : key) + ': ' + escape(value) + '</p>').join('');
      const linked = !!(item.parent_relationship?.parent_key || item.properties?._gpo_parent_product_group);
      const removeControl = linked ? '<p class="ds-bag-linked">Removed with its main piece</p>' : item.instructions?.can_remove === false ? '' : '<button type="button" class="ds-bag-remove" data-ds-bag-remove="' + escape(item.key) + '" aria-label="Remove ' + escape(item.product_title || item.title) + '">Remove</button>';
      const image = item.image && imageUrl(item.image);
      const discounts = (item.line_level_discount_allocations || []).map(allocation => '<p class="ds-bag-discount">' + escape(allocation.discount_application.title) + ' −' + escape(money(allocation.amount, cart.currency)) + '</p>').join('');
      return '<article class="ds-bag-item ajaxcart__product" data-line="' + (index + 1) + '" data-gpo-drawer-item-key="' + escape(item.key) + '"><a class="ds-bag-image ajaxcart__product-image" href="' + escape(localUrl(item.url, root() + 'cart')) + '">' + (image ? '<img src="' + escape(image) + '" alt="' + escape(item.product_title || item.title) + '" width="88" height="88">' : '') + '</a><div class="ds-bag-details ajaxcart__product-description"><a class="ds-bag-name" href="' + escape(localUrl(item.url, root() + 'cart')) + '">' + escape(item.product_title || item.title) + '</a>' + options + properties + '<p>Quantity: ' + escape(item.quantity) + '</p>' + discounts + '<strong>' + escape(money(item.final_line_price ?? item.line_price, cart.currency)) + '</strong>' + removeControl + '</div></article>';
    }).join('');
    const discounts = (cart.cart_level_discount_applications || []).map(discount => '<p class="ds-bag-discount">' + escape(discount.title) + ' −' + escape(money(discount.total_allocated_amount, cart.currency)) + '</p>').join('');
    content.innerHTML = '<form action="' + escape(root() + 'cart') + '" method="post" class="ds-bag-form"><div class="ds-bag-items">' + rows + '</div><footer class="ds-bag-footer ajaxcart__footer">' + discounts + '<div class="ds-bag-subtotal ajaxcart__subtotal"><span>Subtotal</span><strong class="cart-modal-totalprice">' + escape(money(cart.total_price, cart.currency)) + '</strong></div><p class="ds-bag-tax">' + escape(cart.currency) + ' · Free shipping. Taxes calculated at checkout.</p><button type="submit" name="checkout" class="ds-bag-button">Checkout</button><button type="button" class="ds-bag-button ds-bag-secondary" data-ds-bag-close>Continue shopping</button><a class="ds-bag-edit" href="' + escape(root() + 'cart') + '">Edit your bag</a></footer></form>';
    document.dispatchEvent(new CustomEvent('ds:bag-rendered'));
    window.DSEngravingCart?.decorate?.();
    window.DSStudGiftCart?.refresh?.();
  }
  async function refresh() {
    if (removing) return;
    const current = ++request;
    content.innerHTML = '<p class="ds-bag-message" role="status">Loading your bag…</p>';
    content.setAttribute('aria-busy', 'true');
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 12000);
    try {
      const response = await fetch(root() + 'cart.js', {credentials:'same-origin', cache:'no-store', headers:{Accept:'application/json'}, signal:controller.signal});
      if (!response.ok) throw new Error('cart');
      const cart = await response.json();
      if (!Array.isArray(cart.items) || !Number.isFinite(cart.total_price)) throw new Error('cart');
      if (current === request) render(cart);
    } catch {
      if (current === request) content.innerHTML = '<div class="ds-bag-message" role="alert"><p>We couldn’t load your bag. Try again to see its latest contents.</p><button type="button" class="ds-bag-button" data-ds-bag-retry>Try again</button><a class="ds-bag-edit" href="' + escape(root() + 'cart') + '">View your bag</a><button type="button" class="ds-bag-button ds-bag-secondary" data-ds-bag-close>Continue shopping</button></div>';
    } finally {
      clearTimeout(timeout);
      if (current === request) content.removeAttribute('aria-busy');
    }
  }
  function open(trigger) {
    setup();
    if (!dialog.open) {
      opener = trigger || document.activeElement;
      dialog.showModal();
      document.documentElement.classList.add('ds-bag-open');
      document.querySelectorAll(triggers).forEach(node => node.setAttribute('aria-expanded', 'true'));
      dialog.querySelector('[data-ds-bag-close]').focus({preventScroll:true});
    }
    refresh();
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest?.(triggers);
    if (!trigger || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    open(trigger);
  }, true);
  document.addEventListener('ds:cart-state', event => { if (event.detail?.phase === 'added') open(); });
  window.addEventListener('pageshow', () => { if (dialog?.open) refresh(); });
  window.DSCartDrawer = {open, close, refresh: () => { if (dialog?.open) refresh(); }};
})();
